<template>
  <section
    v-if="shopifyData.showProduct == 'true'"
    :id="'blog_gallery_preview_' + shopifyData.nameOfPage"
    :class="shopifyData.nameOfPage"
    class="gallery_preview_sec"
    :style="customizeContent"
  >
    <!-- Sec Content -->
    <div class="sec_content">
      <div :style="{ 'max-width': shopifyData.headingWidth }">
        <h2
          class="main_heading2"
          :style="fontSizeStyles"
          v-html="shopifyData.GalleryPreviewHeading"
        />
      </div>
      <!-- Preview Images -->
      <div class="gallery_preview">
        <div v-for="(item, index) in shopifyData.productData" :key="index">
          <img
            v-if="index <= 3"
            v-lazy="item.previewimage.src"
            :src-placeholder="item.previewimage.placeholder"
            :alt="item.previewimage.alt"
            @click="show = !show"
          />
        </div>
      </div>
      <div class="gallery-cta">
        <button
          class="subtitle"
          aria-label="Gallery CTA"
          @click="show = !show"
          v-html="shopifyData.GalleryCta"
        />
      </div>
      <!-- Overlay -->
      <div class="overlay" :class="{ active: !show }" @click="show = !show" />
      <!-- Preview Images Popup -->
      <div class="gallery_preview_popup" :class="{ active: !show }">
        <div class="gallery_preview_inner">
          <div class="popup_top_row">
            <h3 class="card_heading" v-html="shopifyData.PopupHeading" />
            <img
              src="https://cdn.shopify.com/s/files/1/0577/1178/8125/files/close-icon.png?v=1651150909"
              alt="error"
              class="popup_close"
              aria-label="Close Popup"
              @click="show = !show"
            />
          </div>
          <div class="gallery_cards">
            <div v-for="(value, key) in shopifyData.productData" :key="key" class="card">
              <a
                :href="value.product.productUrl"
                :product-id="value.product.productid"
                class="product_link"
                aria-label="Product Link"
              >
                <div v-if="value.showPreview == 'true'">
                  <div class="card_img">
                    <img v-lazy="value.product.productidImage" alt="Product Image" />
                    <div class="card_preview_img">
                      <!-- <img v-lazy="value.previewimage.src" /> -->
                      <img v-lazy="value.product.productidImage" alt="Product Image" />
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="card_img">
                    <img v-lazy="value.product.productidImage" alt="Product Image" />
                    <div class="card_preview_img">
                      <img v-lazy="value.previewimage.src" alt="Product Preview Image" />
                    </div>
                  </div>
                </div>
                <h4 class="subtitle" v-html="value.product.productTitle" />
                <p class="subtitle_b" v-html="formatPrice(value.product.productidPrice)" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Responsive Slider -->
      <div class="gallery_preview_popup responsive_slider" :class="{ active: !show }">
        <div class="gallery_preview_inner modify-slider">
          <div class="popup_top_row">
            <img
              src="https://cdn.shopify.com/s/files/1/0577/1178/8125/files/close-icon.png?v=1651150909"
              alt="error"
              class="popup_close"
              aria-label="Close Popup"
              @click="show = !show"
            />
          </div>
          <swiper
            :scrollbar="{ hide: false }"
            :modules="modules"
            :slides-per-view="'auto'"
            :space-between="10"
          >
            <swiper-slide v-for="(value, key) in shopifyData.productData" :key="key">
              <div class="card">
                <div v-if="value.showPreviewMob == 'true'" class="card_img">
                  <img v-lazy="value.product.productidImage" alt="Product Image" />
                </div>
                <div v-else class="card_preview_img">
                  <img v-lazy="value.previewimage.src" alt="Product Preview Image" />
                </div>
                <div class="slider_image slider_image_mob bg-black">
                  <div>
                    <p class="subtitle color-white" v-html="value.product.productTitle" />
                    <p class="subtitle_b" v-html="formatPrice(value.product.productidPrice)" />

                    <div class="slider_product_btn">
                      <a
                        :href="value.product.productUrl"
                        :product-id="value.product.productid"
                        class="slider_tmb_btn"
                        aria-label="Slider Button"
                      >
                        <img
                          src="//cdn.shopify.com/s/files/1/0577/1178/8125/t/5/assets/slider-arrow.svg?v=7926845654508591761"
                          alt="Slider Arrow"
                        />
                      </a>
                      <span class="color-white subtitle" v-html="shopifyData.ProductBtn" />
                    </div>
                  </div>
                  <div class="card_img">
                    <img v-lazy="value.product.productidImage" alt="Product Image" />
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';
import { currencyJson } from '@/currency';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Navigation, Scrollbar],
    };
  },
  data() {
    return {
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
      fontSizeStyles: {
        fontSize: '16px',
        // lineHeight: '16px',
      },
      show: true,
    };
  },
  computed: {
    customizeContent() {
      return {
        'padding-top':
          window.innerWidth > 768
            ? `${this.shopifyData.deskPaddingTop}px`
            : `${this.shopifyData.mobPaddingTop}px`,
        'padding-bottom':
          window.innerWidth > 768
            ? `${this.shopifyData.deskPaddingBottom}px`
            : `${this.shopifyData.mobPaddingBottom}px`,
        background: this.shopifyData.bgColor,
      };
    },
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
    this.updateFontSize();
    window.addEventListener('resize', this.updateFontSize);
    this.heightSliderBottom();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateFontSize);
  },
  methods: {
    formatPrice(price) {
      if (!price) return this.currencySymbol + ' 0.00';

      const num =
        this.currencySymbol === '€' ? Number(price.toString().replace(',', '.')).toFixed(2) : price;

      return this.currencySymbol + ' ' + num;
    },
    updateFontSize() {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1200) {
        this.fontSizeStyles.fontSize = `${this.shopifyData.fontSize}px`; // this.shopifyData.fontSize || 16 + 'px';
        // this.fontSizeStyles.lineHeight = '16px';
      } else if (windowWidth <= 1200 && windowWidth >= 425) {
        this.fontSizeStyles.fontSize = '5vw';
        this.fontSizeStyles.lineHeight = '6vw';
      } else {
        this.fontSizeStyles.fontSize = `${this.shopifyData.fontSizeMob}px`;
      }
    },
    heightSliderBottom() {
      // let elmt = document.querySelector(".slider_image_mob");
      // let dynamicHeight = elmt.offsetHeight + "px";
      // console.log(dynamicHeight,'======dynamicHeight=====');
    },
  },
};
</script>

<style scoped>
/* common css */

html {
  scroll-behavior: smooth;
}

.main_heading2 {
  font-family: 'Big Caslon', sans-serif;
  text-align: left;
  /* font-size: 96px; */
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 50px;
}

.card_img img {
  height: 428px;
  width: 100%;
  object-fit: cover;
}

.gallery_preview_sec {
  padding: 52px 56px 0;
}

/* 
.main_heading2 {
  font-size: 5.0vw;
  max-width: 694px;
} */

.gallery_preview {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 17px;
  padding-left: 4px;
}

.gallery-cta {
  padding-left: 4px;
}

.gallery_preview > div > img {
  min-width: 100px;
  height: 140px;
  object-fit: cover;
}

.gallery_preview_popup {
  padding: 19px 40px 140px;
  background: #fff;
  max-width: 1343px;
  margin: 0 auto;
  z-index: 4;
  position: fixed;
  top: 210px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  overflow-y: scroll;
  overscroll-behavior: none;
  min-height: 100vh;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transition: 0.4s;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: linear-gradient(180deg, #ddcec7 0%, #656565 100%), #ffffff;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
  transition: 0.5s;
}

.gallery_preview_popup.active {
  top: 110px;
}

.overlay.active,
.gallery_preview_popup.active {
  opacity: 1;
  visibility: visible;
}

.gallery_cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 48px 12px;
}

.popup_top_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.card_preview_img img {
  width: 100%;
  transition: 0.5s;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  object-fit: cover;
}

@media (hover: hover) {
  .card:hover .card_preview_img img {
    opacity: 0;
  }
}

.gallery_preview img {
  cursor: pointer;
}

.card_img {
  position: relative;
}

.popup_close {
  width: 33px;
  height: 33px;
  position: absolute;
  top: 9px;
  right: 10px;
  cursor: pointer;
}

.card .subtitle {
  margin-top: 7px;
}

.gallery_preview_popup::-webkit-scrollbar {
  width: 5px;
}

.gallery_preview_popup::-webkit-scrollbar-thumb {
  background: grey;
}

.gallery_preview_popup::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Responsive Slider Css Code */
.gallery_preview_popup.responsive_slider {
  display: none;
}

.card {
  position: relative;
  overflow: hidden !important;
}

/* @media only screen and (max-width: 1100px) and (min-width: 575px)  {
  .main_heading2 {
    font-size: 6.5vw;
  max-width: 694px;
  }

} */

@media screen and (max-width: 991px) {
  .gallery_cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 767px) {
  .gallery_cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px 12px;
  }

  .gallery_preview_sec {
    padding: 36px 0px 0 13px;
  }

  .gallery_preview {
    overflow-x: scroll;
    margin-bottom: 10px;
  }

  .main_heading2 {
    margin-bottom: 15px;
    /* max-width: 264px; */
    /* line-height: 41px;
    line-height: 69px; */
  }

  .gallery-cta {
    padding-left: 0px;
  }

  .subtitle {
    margin: 0;
  }
}

/* Responsive Breakpoints */

@media screen and (max-width: 575px) {
  .main_heading2 {
    margin-bottom: 10px;
    /* line-height: 69px; */
    /* line-height: 32px; */
    /* font-size: 24px; */
  }

  .gallery_preview_popup.responsive_slider {
    display: block;
    top: 0;
    z-index: 9;
    padding: 0;
    overflow-y: hidden;
  }

  .gallery_preview_popup {
    display: none;
  }

  .slider_product_btn span {
    margin-bottom: 0 !important;
  }

  /* Responsive Slider Cdd Code */
  .card_preview_img {
    text-align: center;
  }

  .responsive_slider .card_preview_img img {
    position: static;
    opacity: 1;
    width: 100%;
    transform: translate(0, 0);
    height: 100%;
    min-height: auto;
    object-fit: cover;
  }

  .responsive_slider .card_img img {
    height: initial;
    width: initial;
  }

  .responsive_slider .subtitle_b {
    margin-bottom: 11px;
  }

  .responsive_slider .card .subtitle {
    margin: 0px 0 10px;
  }

  .slider_product_btn {
    display: grid;
    justify-content: flex-end;
    margin-right: 0;
    gap: 13px;
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
  }

  .slider_product_btn img {
    transform: rotate(90deg);
  }

  .slider_tmb_btn {
    text-align: center;
    margin: 0 auto;
  }

  .gallery_preview_popup .card_preview_img {
    line-height: 0;
    height: calc(100vh - 125px) !important;
  }

  .responsive_slider .popup_top_row img {
    left: 15px;
    top: 15px;
    right: auto;
    z-index: 9;
  }

  .responsive_slider .popup_top_row {
    margin-bottom: 0;
  }

  .slider_image {
    display: grid;
    padding: 8px;
    grid-template-columns: 1fr 105px;
    gap: 8px;
    justify-content: space-between;
    position: relative;
  }

  .card_img {
    width: 100%;
    height: 100%;
    text-align: end;
  }
}
</style>
<style>
/* Resposnive Slider Css Code */
.responsive_slider .swiper-scrollbar {
  bottom: auto;
  top: 8px;
  background: rgba(0, 0, 0, 0.14);
  height: 3px;
}

.responsive_slider .swiper-scrollbar-drag {
  background: #fff;
  border-radius: 0;
}

.responsive_slider .card_preview_img {
  height: 100%;
}

.responsive_slider .swiper-slide {
  height: 100vh;
}

/* .gallery_preview_sec .main_heading2 {
  line-height: 64px;
} */

@media screen and (max-width: 480px) {
  .responsive_slider .modify-slider .swiper-button-prev,
  .responsive_slider .modify-slider .swiper-button-next {
    display: block;
  }

  .card_preview_img img {
    width: initial !important;
    display: block;
    text-align: center;
    margin: 0 auto;
  }

  .gallery_preview {
    display: flex !important;
  }
}
</style>
